import React from 'react'

// Black Friday: $100 off every builder mic, built into the Build Your Ohma variant prices in Shopify
// (each variant's price lowered by $100, with the regular price as its compare-at price).
// The builder shows the sale whenever Shopify's variants have a compare-at price above the price,
// so it turns on and off with the prices themselves. ?bf=1 previews the look before the prices change.
export const SALE = {
  label: 'Black Friday',
  offUSD: 100
}

export const SALE_PREVIEW = (() => {
  try {
    return new URLSearchParams(window.location.search).get('bf') === '1'
  } catch (e) {
    return false
  }
})()

// Phones: the Black Friday callout sits in the site header, between the menu button and the Ohma logo.
// The header comes from the theme, so it is placed from where those two actually are on the page.
export function SaleHeaderTag({ label, off }) {
  const [box, setBox] = React.useState(null)
  React.useEffect(() => {
    const place = () => {
      const burger = document.querySelector('.ohma-hdr__burger')
      const logo = document.querySelector('.ohma-hdr__logo')
      if (!burger || !logo) return setBox(null)
      const b = burger.getBoundingClientRect()
      const l = logo.getBoundingClientRect()
      if (!b.width || !l.width || l.left - b.right < 60) return setBox(null)
      setBox({ left: b.right, width: l.left - b.right, top: b.top, height: b.height })
    }
    place()
    const t = setTimeout(place, 1500)
    window.addEventListener('resize', place)
    return () => {
      clearTimeout(t)
      window.removeEventListener('resize', place)
    }
  }, [])
  if (!box) return null
  return React.createElement(
    'div',
    { className: 'sale-hdr', style: { left: box.left, width: box.width, top: box.top, height: box.height } },
    React.createElement('span', null, label, React.createElement('br'), `$${off} off`)
  )
}
